module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.10962/img/storefront-header-blobs.svg"